import _ from 'lodash'
import { L2TabularListItemSummary } from '../l2/L2TabularListItem'
import { L2TabularListContent, L2TabularListHeader, L2TabularListRoot } from '../l2/L2TabularList'

interface L3EncounterIdsProps {
	cmsId?: string
	memberId: string
	memberGuid: string
	encounterGuid: string
}

const L3EncounterIds = ({cmsId, memberId, memberGuid, encounterGuid}: L3EncounterIdsProps) => {
	return (
		<L2TabularListRoot columnCount={4}>
			<L2TabularListHeader>
				<div>CMS ID</div>
				<div>Member ID</div>
				<div>Member GUID</div>
				<div>Encounter GUID</div>
			</L2TabularListHeader>
			<L2TabularListContent>
				<L2TabularListItemSummary>
					<div>{cmsId}</div>
					<div>{memberId}</div>
					<div>{memberGuid}</div>
					<div>{encounterGuid}</div>
				</L2TabularListItemSummary>
			</L2TabularListContent>
		</L2TabularListRoot>
	)
}

export default L3EncounterIds
